import { OverallStatus, PODReviewStatus } from '../enums/DeliveryEnum';
import {OrderFiltersType} from "../graphql/types/OrderFiltersType";
import { t } from '../i18n';


export const overallStatusOptions = Object.keys(OverallStatus)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
        label: t(`enum.overallStatus.${key}`),
        value: key
    }));

export const isComplaintOptions = [
    { label: t('config.isComplaint.yes'), value: true },
    { label: t('config.isComplaint.no'), value: false }
];

export const hasExceptionOptions = [
    { label: t('config.hasException.yes'), value: true },
    { label: t('config.hasException.no'), value: false }
];

export const nextActionOptions = [
    { label: t('config.nextAction.hold'), value: 1 },
    { label: t('config.nextAction.reDeliver'), value: 2 },
    { label: t('config.nextAction.return'), value: 3 },
    { label: t('config.nextAction.reSort'), value: 5 },
];

// 英文 actionName 映射表，用于后端请求
export const ACTION_NAME_MAP: Record<string, string> = {
    '1': 'Hold',
    '2': 'ReDeliver',
    '3': 'Return',
    '4': 'Compensate',  // 添加赔付映射，仅用于显示
    '5': 'ReSort'
};


export const exceptionStatusOptions = [
    { label: t('config.exceptionStatus.open'), value: true },
    { label: t('config.exceptionStatus.resolved'), value: false }
];

export const hasCloseRecordOptions = [
    { label: t('config.hasCloseRecord.yes'), value: true },
    { label: t('config.hasCloseRecord.no'), value: false }
];

export const podReviewStatusOptions = [
    {label: t('enum.podReviewStatus.MANUAL_PENDING'), value: 'MANUAL_PENDING'},
    {label: t('enum.podReviewStatus.MANUAL_APPROVED'), value: 'MANUAL_APPROVED'},
    {label: t('enum.podReviewStatus.MANUAL_DISAPPROVED'), value: 'MANUAL_DISAPPROVED'}
];

export const podReviewL1ReasonOptions = [
    {label: t('podReview.reasons.LABEL_PHOTO'), value: 'LABEL_PHOTO'},
    {label: t('podReview.reasons.ADDRESS_PHOTO'), value: 'ADDRESS_PHOTO'},
    {label: t('podReview.reasons.DELIVERY_LOCATION_PHOTO'), value: 'DELIVERY_LOCATION_PHOTO'},
    {label: t('podReview.reasons.SPECIAL_VIOLATION'), value: 'SPECIAL_VIOLATION'},
];

export const podReviewL2ByL1Options: Record<string, {label: string; value: string}[]> = {
    LABEL_PHOTO: [
        {label: t('podReview.reasons.UNRECOGNIZABLE_LABEL'), value: 'UNRECOGNIZABLE_LABEL'},
        {label: t('podReview.reasons.MISSING_LABEL'), value: 'MISSING_LABEL'},
    ],
    ADDRESS_PHOTO: [
        {label: t('podReview.reasons.WRONG_ADDRESS'), value: 'WRONG_ADDRESS'},
        {label: t('podReview.reasons.MISSING_ADDRESS_PHOTO'), value: 'MISSING_ADDRESS_PHOTO'},
        {label: t('podReview.reasons.INCOMPLETE_ADDRESS_INFO'), value: 'INCOMPLETE_ADDRESS_INFO'},
    ],
    DELIVERY_LOCATION_PHOTO: [
        {label: t('podReview.reasons.DELIVERED_TO_USPS_BOX'), value: 'DELIVERED_TO_USPS_BOX'},
        {label: t('podReview.reasons.DELIVERED_TO_POST_OFFICE'), value: 'DELIVERED_TO_POST_OFFICE'},
        {label: t('podReview.reasons.DELIVERED_TO_OUTDOOR_UNSAFE'), value: 'DELIVERED_TO_OUTDOOR_UNSAFE'},
        {label: t('podReview.reasons.DELIVERED_TO_INDOOR_UNSAFE'), value: 'DELIVERED_TO_INDOOR_UNSAFE'},
        {label: t('podReview.reasons.MISSING_DELIVERY_LOCATION_PHOTO'), value: 'MISSING_DELIVERY_LOCATION_PHOTO'},
    ],
    SPECIAL_VIOLATION: [
        {label: t('podReview.reasons.FALSE_DELIVERY'), value: 'FALSE_DELIVERY'},
        {label: t('podReview.reasons.USER_PRIVACY'), value: 'USER_PRIVACY'},
        {label: t('podReview.reasons.DRIVER_FRAUD'), value: 'DRIVER_FRAUD'},
        {label: t('podReview.reasons.VIOLENT_DELIVERY'), value: 'VIOLENT_DELIVERY'},
    ],
};

// 三级原因：「送错地址」「投递至室外不安全区域」下挂三级，其余二级均为叶子节点
export const podReviewL3ByL2Options: Record<string, {label: string; value: string}[]> = {
    WRONG_ADDRESS: [
        {label: t('podReview.reasons.WRONG_STREET_NUMBER'), value: 'WRONG_STREET_NUMBER'},
        {label: t('podReview.reasons.WRONG_HOUSE_NUMBER'), value: 'WRONG_HOUSE_NUMBER'},
        {label: t('podReview.reasons.WRONG_UNIT_NUMBER'), value: 'WRONG_UNIT_NUMBER'},
    ],
    DELIVERED_TO_OUTDOOR_UNSAFE: [
        {label: t('podReview.reasons.DELIVERED_TO_LAWN_OR_ROADSIDE'), value: 'DELIVERED_TO_LAWN_OR_ROADSIDE'},
        {label: t('podReview.reasons.DELIVERED_TO_COMMON_AREA'), value: 'DELIVERED_TO_COMMON_AREA'},
        {label: t('podReview.reasons.DELIVERED_TO_BUILDING_EXTERIOR'), value: 'DELIVERED_TO_BUILDING_EXTERIOR'},
        {label: t('podReview.reasons.DELIVERED_TO_BUSINESS_ENTRANCE'), value: 'DELIVERED_TO_BUSINESS_ENTRANCE'},
        {label: t('podReview.reasons.DELIVERED_TO_UNKNOWN_AREA'), value: 'DELIVERED_TO_UNKNOWN_AREA'},
    ],
};

export const ParcelInitialValue: OrderFiltersType = {
    trackingNumbers: undefined,
    platformId: undefined,
    channelId: undefined,
    channelOrderNumber:undefined,
    externalTrackingNumber: undefined,
    sortingCodeSegment1: undefined,
    sortingCodeSegment2: undefined,
    sortingCodeSegment3: undefined,
    hubId: undefined,
    warehouseId: undefined,
    receiverZipcode: undefined,
    receiverZipcodeInput: undefined,
    addrModified: undefined,
    hasManded: undefined,
    // 默认时间范围不写入 URL hash：由页面/查询层在运行时按“最近一周”补默认值
    orderTime: undefined,
    receivedAtHub: null,
    deliverAt: null,
    destHubArrivedAt: null,
    destWarehouseArrivedAt: null,
    overallStatus: undefined,
    isComplaint: undefined,
    podReviewStatus: undefined,
    isAbnormal: undefined,
    exceptionReasonCode: undefined,
    markExceptionAt: null,
    nextAction: undefined,
    isHasBeenSetException: undefined,
    exceptionHubId: undefined,
    exceptionWarehouseId: undefined,
    pickupHubId: undefined,
    cooperationWarehouseId: undefined,
    deliveredAt: null,
    lastDeliveryScanTime: null,
    deliveredDspId: undefined,
    deliveredDspIds: undefined,
    driverAccountIds: undefined,
};